// Componente Footer - Pie de página de la aplicación
// Basado en el mockup proporcionado (Pine & Co style)

import { Link } from 'react-router-dom'
import './Footer.css'

/**
 * Componente Footer
 * Pie de página con diseño moderno (Tailwind) basado en el mockup
 */
function Footer() {
  return (
    <footer className="bg-background-dark text-white py-12 px-4 md:px-10 mt-auto">
      <div className="mx-auto max-w-[1280px] grid grid-cols-1 md:grid-cols-4 gap-10">
        {/* Brand Column */}
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-2">
            <div className="size-6 text-primary">
              <svg className="w-full h-full" fill="none" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                <path d="M39.5563 34.1455V13.8546C39.5563 15.708 36.8773 17.3437 32.7927 18.3189C30.2914 18.916 27.263 19.2655 24 19.2655C20.737 19.2655 17.7086 18.916 15.2073 18.3189C11.1227 17.3437 8.44365 15.708 8.44365 13.8546V34.1455C8.44365 35.9988 11.1227 37.6346 15.2073 38.6098C17.7086 39.2069 20.737 39.5564 24 39.5564C27.263 39.5564 30.2914 39.2069 32.7927 38.6098C36.8773 37.6346 39.5563 35.9988 39.5563 34.1455Z" fill="currentColor"></path>
              </svg>
            </div>
            <h2 className="text-xl font-bold tracking-tight">Pine & Co</h2>
          </div>
          <p className="text-gray-400 text-sm font-light leading-relaxed max-w-xs tracking-tight">
            Llevando la belleza atemporal de la madera de pino a los hogares modernos. Sostenible, robusto y elegante.
          </p>
        </div>

        {/* Shop Column */}
        <div>
          <h4 className="font-semibold mb-4 tracking-tight">Tienda</h4>
          <ul className="flex flex-col gap-2 text-gray-400 text-sm font-light">
            <li><Link to="/productos" className="hover:text-primary transition-colors tracking-tight">Todos los Muebles</Link></li>
            <li><Link to="/productos?sort=newest" className="hover:text-primary transition-colors tracking-tight">Novedades</Link></li>
            <li><Link to="/productos?sort=best_selling" className="hover:text-primary transition-colors tracking-tight">Más Vendidos</Link></li>
            <li><Link to="/productos?filter=offers" className="hover:text-primary transition-colors tracking-tight">En Oferta</Link></li>
          </ul>
        </div>

        {/* Support Column */}
        <div>
          <h4 className="font-semibold mb-4 tracking-tight">Soporte</h4>
          <ul className="flex flex-col gap-2 text-gray-400 text-sm font-light">
            <li><Link to="/contacto" className="hover:text-primary transition-colors tracking-tight">Contáctanos</Link></li>
            <li><Link to="/ayuda#envios" className="hover:text-primary transition-colors tracking-tight">Política de Envíos</Link></li>
            <li><Link to="/ayuda#devoluciones" className="hover:text-primary transition-colors tracking-tight">Devoluciones y Cambios</Link></li>
            <li><Link to="/ayuda#faq" className="hover:text-primary transition-colors tracking-tight">FAQ</Link></li>
          </ul>
        </div>

        {/* Newsletter Column */}
        <div>
          <h4 className="font-semibold mb-4 tracking-tight">Boletín</h4>
          <p className="text-gray-400 text-sm mb-3 font-light tracking-tight">Suscríbete para recibir ofertas especiales e inspiración.</p>
          <div className="flex gap-2">
            <input className="bg-gray-800 border-none rounded text-white text-sm px-3 py-2 flex-1 focus:ring-1 focus:ring-primary placeholder:text-gray-500 font-light tracking-tight" placeholder="Tu correo electrónico" type="email"/>
            <button className="bg-primary hover:bg-primary/90 text-white px-4 py-2 rounded text-sm font-medium tracking-tight">Unirse</button>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-500 text-sm font-light tracking-tight">
        &copy; {new Date().getFullYear()} Pine & Co. Todos los derechos reservados.
      </div>
    </footer>
  )
}

export default Footer
